import i18next from 'i18next';
import en from './translations/en.json';
import ru from './translations/ru.json';

const params = new URLSearchParams(document.location.search);
const urlLang = params.get("lang") || '';
const lng = ['en', 'ru'].includes(urlLang) ? urlLang : 'en';

i18next.init({
  interpolation: { escapeValue: false },
  lng,
  fallbackLng: 'en',
  resources: {
    en: {
      translation: en,
    },
    ru: {
      translation: ru,
    },
  }
});

export const i18nextInstance = i18next;



// WEBPACK FOOTER //
// ./src/i18n.js